/**
 * Parse target element from coeffects
 *
 * @param coeffects
 */
export default function getTargetElement(coeffects) {
	if (
		coeffects &&
		coeffects.action &&
		coeffects.action.payload &&
		coeffects.action.payload.event &&
		coeffects.action.payload.event.target
	)
		return coeffects.action.payload.event.target;

	return coeffects.host;
}
